var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fee_valid_from",
            label: _vm._f("pgettext")("Validity", "ContractServiceFee"),
            labelColsMd: "3",
            contentColsMd: "7",
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "The validity period of the fee.",
              "ContractServiceFee|Tooltip"
            ),
            contentClass: "form-row"
          }
        },
        [
          _c(
            "DIV",
            { staticClass: "col" },
            [
              _c("ItpFormDatetime", {
                attrs: { name: "valid_from", required: "" },
                model: {
                  value: _vm.item.valid_from,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "valid_from", $$v)
                  },
                  expression: "item.valid_from"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "DIV",
            { staticClass: "col" },
            [
              _c("ItpFormDatetime", {
                attrs: { name: "valid_to" },
                model: {
                  value: _vm.item.valid_to,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "valid_to", $$v)
                  },
                  expression: "item.valid_to"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "description" }, slot: "description" }, [
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("pgettext")(
                      "The start date is required. Set the end date only if different from the end of the service.",
                      "ContractServiceFee|Tooltip"
                    )
                  ) +
                  "\n      "
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fee_valid_to",
            label: _vm._f("pgettext")("Amount", "ContractServiceFee"),
            labelColsMd: "3",
            contentColsMd: "5",
            labelAlign: _vm.labelAlign,
            contentClass: "input-group",
            helpTooltip: _vm._f("pgettext")(
              "The price per unit of the fee.",
              "ContractServiceFee|Tooltip"
            )
          }
        },
        [
          _c("ItpFormInput", {
            staticClass: "col-9",
            attrs: {
              mask: "number",
              unmask: "typed",
              name: "fee_amount",
              scale: "4",
              required: ""
            },
            model: {
              value: _vm.item.amount,
              callback: function($$v) {
                _vm.$set(_vm.item, "amount", $$v)
              },
              expression: "item.amount"
            }
          }),
          _vm._v(" "),
          _c("ItpFormSelect", {
            staticClass: "col-3",
            attrs: {
              name: "currency",
              options: _vm.currencies,
              textField: "code",
              valueField: "code",
              required: ""
            },
            model: {
              value: _vm.item.currency,
              callback: function($$v) {
                _vm.$set(_vm.item, "currency", $$v)
              },
              expression: "item.currency"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fee_unit",
            label: _vm._f("pgettext")("Invoice unit", "ContractServiceFee"),
            labelColsMd: "3",
            contentColsMd: "2",
            labelAlign: _vm.labelAlign,
            contentClass: "input-group",
            helpTooltip: _vm._f("pgettext")(
              "The unit used for billing.",
              "ContractServiceFee|Tooltip"
            )
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "fee_unit", required: "" },
            model: {
              value: _vm.item.unit,
              callback: function($$v) {
                _vm.$set(_vm.item, "unit", $$v)
              },
              expression: "item.unit"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fee_quantity",
            label: _vm._f("pgettext")("Quantity", "ContractServiceFee"),
            labelColsMd: "3",
            contentColsMd: "2",
            labelAlign: _vm.labelAlign,
            contentClass: "input-group",
            helpTooltip: _vm._f("pgettext")(
              "The quantity to bill for each period.",
              "ContractServiceFee|Tooltip"
            )
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { type: "number", name: "fee_quantity" },
            model: {
              value: _vm.item.quantity,
              callback: function($$v) {
                _vm.$set(_vm.item, "quantity", $$v)
              },
              expression: "item.quantity"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fee_unit_of_quantity",
            label: _vm._f("pgettext")("Unit of quantity", "ContractServiceFee"),
            labelColsMd: "3",
            contentColsMd: "2",
            labelAlign: _vm.labelAlign,
            contentClass: "input-group",
            helpTooltip: _vm._f("pgettext")(
              "The unit of quantity - if different from the billing quantity.",
              "ContractServiceFee|Tooltip"
            )
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "fee_unit_of_quantity" },
            model: {
              value: _vm.item.unit_of_quantity,
              callback: function($$v) {
                _vm.$set(_vm.item, "unit_of_quantity", $$v)
              },
              expression: "item.unit_of_quantity"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fee_inflation_indexed",
            label: _vm._f("pgettext")(
              "Inflation indexed",
              "ContractServiceFee"
            ),
            labelColsMd: "3",
            contentColsMd: "9",
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "Indicates if the unit price should be automatically adjusted based on indexation rules.",
              "ContractServiceFee|Tooltip"
            )
          }
        },
        [
          _c("ItpFormCheckbox", {
            attrs: { name: "fee_inflation_indexed" },
            model: {
              value: _vm.item.inflation_indexed,
              callback: function($$v) {
                _vm.$set(_vm.item, "inflation_indexed", $$v)
              },
              expression: "item.inflation_indexed"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "transaction_notes",
            label: _vm._f("pgettext")("Invoice notes", "ContractServiceFee"),
            labelColsMd: "3",
            contentColsMd: "9",
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "Note to display on the invoice line.",
              "ContractServiceFee|Tooltip"
            )
          }
        },
        [
          _c("TransactionNotesEditor", {
            model: {
              value: _vm.item.transaction_notes,
              callback: function($$v) {
                _vm.$set(_vm.item, "transaction_notes", $$v)
              },
              expression: "item.transaction_notes"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "fee_notes",
            label: _vm._f("pgettext")("Notes", "ContractServiceFee"),
            labelColsMd: "3",
            contentColsMd: "9",
            labelAlign: _vm.labelAlign,
            helpTooltip: _vm._f("pgettext")(
              "Notes for internal use only.",
              "ContractServiceFee|Tooltip"
            )
          }
        },
        [
          _c("ItpFormTextarea", {
            attrs: { name: "fee_notes" },
            model: {
              value: _vm.item.notes,
              callback: function($$v) {
                _vm.$set(_vm.item, "notes", $$v)
              },
              expression: "item.notes"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }